
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Input } from '@/components/ui/input'
import { Search, Filter } from 'lucide-react'
import type { FilterPlan, FilterBilling } from '../types'

interface TenantsFiltersProps {
  searchQuery: string
  setSearchQuery: (query: string) => void
  filterPlan: FilterPlan
  setFilterPlan: (plan: FilterPlan) => void
  filterBilling: FilterBilling
  setFilterBilling: (status: FilterBilling) => void
}

export function TenantsFilters({
  searchQuery,
  setSearchQuery,
  filterPlan,
  setFilterPlan,
  filterBilling,
  setFilterBilling,
}: TenantsFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 items-center bg-muted/40 p-1 rounded-lg border">
      <div className="relative flex-1 w-full">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search tenants by name or domain..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-9 border-0 bg-transparent focus-visible:ring-0"
        />
      </div>
      <div className="h-6 w-px bg-border hidden sm:block" />
      <div className="flex items-center gap-2 w-full sm:w-auto px-2">
        <Filter className="h-3.5 w-3.5 text-muted-foreground" />
        
        <Select value={filterPlan} onValueChange={(v) => setFilterPlan(v as FilterPlan)}>
          <SelectTrigger className="w-[120px] h-8 border-0 bg-transparent focus:ring-0">
            <SelectValue placeholder="Plan" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Plans</SelectItem>
            <SelectItem value="starter">Starter</SelectItem>
            <SelectItem value="professional">Professional</SelectItem>
            <SelectItem value="enterprise">Enterprise</SelectItem>
          </SelectContent>
        </Select>

        <div className="h-4 w-px bg-border hidden sm:block" />

        <Select value={filterBilling} onValueChange={(v) => setFilterBilling(v as FilterBilling)}>
          <SelectTrigger className="w-[120px] h-8 border-0 bg-transparent focus:ring-0">
            <SelectValue placeholder="Billing" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="active">Active</SelectItem>
            <SelectItem value="trial">Trial</SelectItem>
            <SelectItem value="past_due">Past Due</SelectItem>
            <SelectItem value="cancelled">Cancelled</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
